import { Box } from '@mui/material';
import { ExoSkeleton } from '../../components/exo/ExoSkeleton';

// Text lines of a fake paragraph — the last line is shorter, like real text
const Paragraph = ({ lines = 4, lastLineWidth = '55%' }) => (
  <Box className="flex flex-col" sx={{ gap: '9px', marginBottom: '22px' }}>
    {Array(lines - 1)
      .fill(null)
      .map((_, index) => (
        <ExoSkeleton key={index} size="13px" borderRadius="6px" />
      ))}
    <ExoSkeleton width={lastLineWidth} size="13px" borderRadius="6px" />
  </Box>
);

// Mirrors the ArticleView layout (breadcrumb, title, meta, roles panel,
// contents box, article text and the xl-only toc sidebar) so the page
// doesn't jump when the entry arrives
export const ArticleSkeleton = () => (
  <>
    <Box component="main" className="flex-1 min-w-0 h-full overflow-y-auto">
      <Box className="mx-auto" sx={{ maxWidth: '860px', padding: '28px 40px 80px' }}>
        <ExoSkeleton width="280px" size="14px" borderRadius="6px" />

        <Box sx={{ margin: '18px 0 8px' }}>
          <ExoSkeleton width="65%" size="32px" borderRadius="8px" />
        </Box>

        <Box
          className="flex items-center flex-wrap"
          sx={{ gap: '14px', marginBottom: '22px' }}
        >
          <ExoSkeleton width="110px" size="18px" borderRadius="99px" />
          <ExoSkeleton width="150px" size="18px" borderRadius="99px" />
          <ExoSkeleton width="90px" size="18px" borderRadius="99px" />
        </Box>

        <Box sx={{ marginBottom: '24px' }}>
          <ExoSkeleton size="64px" borderRadius="11px" />
        </Box>

        <Box sx={{ aspectRatio: '16 / 9', marginBottom: '18px' }}>
          <ExoSkeleton className="h-full" size="100%" borderRadius="14px" />
        </Box>

        <Box className="flex" sx={{ gap: '10px', margin: '0 0 26px' }}>
          <ExoSkeleton width="120px" size="36px" borderRadius="9px" />
        </Box>

        <Box sx={{ marginBottom: '14px' }}>
          <ExoSkeleton width="40%" size="22px" borderRadius="7px" />
        </Box>
        <Paragraph lines={5} lastLineWidth="70%" />
        <Paragraph lines={4} lastLineWidth="45%" />

        <Box sx={{ margin: '12px 0 14px' }}>
          <ExoSkeleton width="34%" size="22px" borderRadius="7px" />
        </Box>
        <Paragraph lines={4} lastLineWidth="60%" />
        <Paragraph lines={3} lastLineWidth="35%" />
      </Box>
    </Box>

    <Box
      component="aside"
      className="hidden xl:block flex-none h-full overflow-y-auto"
      sx={{
        width: '250px',
        padding: '30px 22px',
        borderLeft: '1px solid var(--border)',
      }}
    >
      <ExoSkeleton width="110px" size="12px" borderRadius="6px" />
      <Box className="flex flex-col" sx={{ gap: '12px', marginTop: '16px' }}>
        <ExoSkeleton width="85%" size="12px" borderRadius="6px" />
        <ExoSkeleton width="70%" size="12px" borderRadius="6px" />
        <ExoSkeleton width="90%" size="12px" borderRadius="6px" />
        <ExoSkeleton width="60%" size="12px" borderRadius="6px" />
        <ExoSkeleton width="75%" size="12px" borderRadius="6px" />
      </Box>
    </Box>
  </>
);
